import { makeStyles } from "@material-ui/core/styles";

export const usePrivacySettingsStyles = makeStyles(theme => ({
  section: {
    marginBottom: theme.spacing(1),
    backgroundColor: "#000000",
    padding: "20px 18px 20px",
    borderRadius: "8px",
    color: "white",
    [theme.breakpoints.down("sm")]: {
      padding: "20px 12px 16px",
    },
  },
  sectionTitle: {
    color: "#f7f7f7",
    marginBottom: "6px",
    fontWeight: 700,
    fontSize: "32px",
    lineHeight: 1.2,
    [theme.breakpoints.down("sm")]: {
      fontSize: "20px",
    },
  },
  passwordText: {
    color: "#F0F0F0",
    marginBottom: "28px",
    fontSize: "20px",
    lineHeight: 1.2,
    opacity: 0.9,
    [theme.breakpoints.down("sm")]: {
      fontSize: "14px",
    },
  },
  groupTitle: {
    color: "#ffffff",
    fontWeight: 700,
    fontSize: "24px",
    marginBottom: "14px",
    lineHeight: 1.2,
    marginTop: "24px",
    [theme.breakpoints.down("sm")]: {
      fontSize: "16px",
    },
  },
  groupWrapper: {
    display: "flex",
    flexDirection: "column",
    gap: "8px",
    marginBottom: "16px",
  },
  settingCard: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: "8px",
    backgroundColor: "#131313",
    minHeight: "72px",
    padding: "0 18px",
    borderRadius: "10px",
  },
  settingLabel: {
    color: "#f8f8f8",
    fontSize: "16px",
    fontWeight: 500,
    [theme.breakpoints.down("sm")]: {
      fontSize: "14px",
    },
  },
  switchRoot: {
    width: 52,
    height: 32,
    padding: 0,
  },
  switchBase: {
    padding: 3,
    "&$switchChecked": {
      transform: "translateX(20px)",
      color: "#ffffff",
      "& + $switchTrack": {
        backgroundColor: "#ff4fa2",
        borderColor: "#ff4fa2",
        opacity: 1,
      },
    },
  },
  switchChecked: {},
  switchThumb: {
    width: 26,
    height: 26,
    boxShadow: "none",
  },
  switchTrack: {
    borderRadius: 16,
    backgroundColor: "#31343d",
    border: "1px solid #31343d",
    opacity: 1,
  },
  blacklistList: {
    display: "flex",
    flexDirection: "column",
    gap: "8px",
  },
  blacklistRow: {
    backgroundColor: "#131313",
    minHeight: "72px",
    borderRadius: "10px",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: "8px",
    padding: "0 18px",
  },
  blacklistUser: {
    display: "flex",
    alignItems: "center",
    gap: "12px",
  },
  blacklistAvatar: {
    width: 48,
    height: 48,
    backgroundColor: "#2b2f38",
    color: "#ffffff",
  },
  blacklistName: {
    fontSize: "20px",
    fontWeight: 600,
    color: "#f4f4f4",
    lineHeight: 1.2,
  },
  blacklistAction: {
    width: "44px",
    height: "44px",
    borderRadius: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "#12151c",
    flexShrink: 0,
  },
  blacklistIconButton: {
    padding: 8,
    color: "inherit",
  },
  blacklistEmpty: {
    color: "#a0a0a0",
    fontSize: "16px",
    marginTop: theme.spacing(0.5),
    marginBottom: theme.spacing(1),
  },
  blacklistActionIcon: {
    color: "#f0f0f0",
    fontSize: "22px",
  },
  buttonContainer: {
    display: "flex",
    justifyContent: "flex-end",
    marginTop: theme.spacing(2),
    gap: "10px",
  },
  cancelButton: {
    color: "#e7e7e7",
    width: "90px",
    border: "1px solid #2f2f2f",
    height: "40px",
    fontSize: "14px",
    fontWeight: 600,
    borderRadius: "8px",
    textTransform: "none",
    backgroundColor: "#151515",
    "&:hover": {
      backgroundColor: "#242424",
    },
    [theme.breakpoints.down("sm")]: {
      display: "none",
    },
  },
  saveButton: {
    color: "white",
    backgroundColor: "#ff4fa2",
    width: "90px",
    border: "1px solid #ff4fa2",
    height: "40px",
    fontSize: "14px",
    fontWeight: 600,

    "&:hover": {
      backgroundColor: "#ec3e94",
    },
    textTransform: "none",
    padding: "8px 16px",
    borderRadius: "8px",
  },
  unblockDialogPaper: {
    backgroundColor: "#0d0d0d",
    color: "#ffffff",
    borderRadius: "16px",
    padding: "40px",
    maxWidth: "780px",
    width: "100%",
    border: "1px solid #222",
    boxSizing: "border-box",
    [theme.breakpoints.down("sm")]: {
      padding: "36px 12px",
    },
    [theme.breakpoints.down("xs")]: {
      margin: theme.spacing(2),
    },
  },
  unblockDialogHeader: {
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "space-between",
    gap: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  unblockDialogTitle: {
    fontWeight: 700,
    fontSize: "24px",
    lineHeight: 1.3,
    color: "#ffffff",
    paddingRight: theme.spacing(1),
    [theme.breakpoints.down("sm")]: {
      fontSize: "20px",
    },
  },
  unblockDialogClose: {
    color: "#a8a8a8",
    padding: 4,
    marginTop: -4,
    marginRight: -4,
    "&:hover": {
      color: "#ffffff",
      backgroundColor: "rgba(255,255,255,0.06)",
    },
  },
  unblockDialogBody: {
    color: "#FFFFFFCC",
    fontSize: "14px",
    lineHeight: 1.55,
    margin: 0,
    marginBottom: "30px",
  },
  unblockDialogUserCard: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    gap: theme.spacing(1.5),
    backgroundColor: "#1F1F1F80",
    borderRadius: "12px",
    padding: "12px",
    marginBottom: theme.spacing(3),
  },
  unblockDialogUserName: {
    fontWeight: 600,
    fontSize: "20px",
    color: "#ffffff",
    lineHeight: 1.2,
  },
  unblockDialogAvatar: {
    width: 48,
    height: 48,
    flexShrink: 0,
    backgroundColor: "#2b2f38",
  },
  unblockDialogActions: {
    display: "flex",
    flexDirection: "row",
    alignItems: "stretch",
    justifyContent: "stretch",
    width: "100%",
    boxSizing: "border-box",
    padding: "0 !important",
    margin: 0,
    flexWrap: "nowrap",
    gap: "32px",
    "& > *": {
      flex: "1 1 0",
      minWidth: 0,
      margin: "0 !important",
    },
    [theme.breakpoints.down("sm")]: {
      flexDirection: "column",
      gap: "8px",
      alignItems: "stretch",
      "& > *": {
        flex: "none",
        width: "100%",
        maxWidth: "100%",
      },
    },
  },
  unblockDialogCancel: {
    color: "#ffffff",
    border: "1px solid #ff4fa2",
    backgroundColor: "transparent",
    width: "100%",
    minWidth: 0,
    height: "44px",
    fontSize: "20px",
    fontWeight: 600,
    borderRadius: "10px",
    textTransform: "none",
    "&:hover": {
      backgroundColor: "rgba(255, 79, 162, 0.08)",
    },
    [theme.breakpoints.down("sm")]: {
      fontSize: "14px",
      fontWeight: 500,
    },
  },
  unblockDialogConfirm: {
    color: "#ffffff",
    backgroundColor: "#ff4fa2",
    border: "1px solid #ff4fa2",
    width: "100%",
    minWidth: 0,
    height: "44px",
    fontSize: "20px",
    fontWeight: 600,
    borderRadius: "10px",
    textTransform: "none",
    "&:hover": {
      backgroundColor: "#ec3e94",
      borderColor: "#ec3e94",
    },
    "&:disabled": {
      opacity: 0.6,
    },
    [theme.breakpoints.down("sm")]: {
      fontSize: "14px",
      fontWeight: 500,
    },
  },
}));
